import { ref } from 'vue'

import type { Ref } from 'vue'
import type { TutorKanbanCardProps } from '../types/interfaces'

interface TutorKanbanCardOptions {
  props: TutorKanbanCardProps
  onClick: (tutorId: number) => void
}

interface TutorKanbanCardReturn {
  tooltip: Ref<boolean>
  setTooltip: (value: boolean) => void
  handleClick: () => void
}

export const useTutorKanbanCard = ({ props, onClick }: TutorKanbanCardOptions): TutorKanbanCardReturn => {
  const tooltip = ref<boolean>(false)

  const setTooltip = (value: boolean): void => {
    tooltip.value = value
  }

  const handleClick = (): void => {
    onClick(props.tutorId)
  }

  return {
    tooltip,
    setTooltip,
    handleClick,
  }
}
